import { useState } from "react";

import { SnackbarMessage, useSnackbar } from ".";
import { RolloverResponse } from "../pages/NewRollovers/Rollovers.types";
import { rollOverClientApi } from "../api-client-nswag/taxportal-client-runtime";
import { NOTIFICATION_MESSAGES } from "../pages/NewRollovers/Rollovers.constants";

const { DEFAULT_SCHEDULE_DAYS } = NOTIFICATION_MESSAGES;

function useRolloverRequest(siteID: number) {
  const [data, setData] = useState<RolloverResponse>({ pending: true, fulfilled: true, rollovers: [] });
  const { showSnackbar } = useSnackbar();
  const [clientID, setClientID] = useState<number>();
  const [scheduleDays, setScheduleDays] = useState<number>(DEFAULT_SCHEDULE_DAYS);
  const [rolloverOptions, setRollOverOptions] = useState<any>("");
  const [taxYear, setTaxYear] = useState<string>();
  const [newTaxValue, setNewTaxYear] = useState<string>();
  const [appName, setAppName] = useState<string>();

  const fetchData = async () => {
    setData({ pending: true, fulfilled: true, rollovers: [] });
    try {
      if (typeof siteID === "undefined") return;
      const { hQRolloversTracks, mdmClientId, rollOverScheduleDays, rolloverOptions, taxYear, newTaxYear, appName } =
        await rollOverClientApi.taxPortal_GetAllRolloverInfo(siteID!);
      setData({ pending: false, fulfilled: true, rollovers: hQRolloversTracks });
      setClientID(mdmClientId);
      setScheduleDays(rollOverScheduleDays);
      setRollOverOptions(rolloverOptions);
      setTaxYear(taxYear);
      setNewTaxYear(newTaxYear);
      setAppName(appName);
    } catch (error: any) {
      setData({ pending: false, fulfilled: false, rollovers: [] });
      showSnackbar({ message: SnackbarMessage.NO_SITE, severity: "error" });
      const message = typeof siteID === "undefined" ? SnackbarMessage.NO_SITE : SnackbarMessage.ERROR;
      showSnackbar({ message: message, severity: "error" });
    }
  };

  return { data, fetchData, clientID, scheduleDays, rolloverOptions, taxYear, newTaxValue, appName  };
}

export default useRolloverRequest;
